import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrontPageComponent } from './front-page/front-page.component';
import { ReportComponent } from './report.component';
import { StylesComponent } from './styles/styles.component';
import { IntroductionComponent } from './introduction/introduction.component';
import { ScoreSummaryComponent } from './score-summary/score-summary.component';
// Imported directly rather than through LibModule: LibModule bootstraps Okta at
// module-evaluation time, which a report-rendering consumer must not inherit.
import { LibChartModule } from '../chart';
import { PrimaryStyleComponent } from './primary-style/primary-style.component';
import { LeastStyleComponent } from './least-style/least-style.component';
import { StyleExpressionComponent } from './style-expression/style-expression.component';
import { StyleCombinationsComponent } from './style-combinations/style-combinations.component';
import { SecondaryStyleComponent } from './secondary-style/secondary-style.component';
import { ImprovementsComponent } from './improvements/improvements.component';
import { CoacheeLeastStyleComponent } from './coachee-report/coachee-least-style/coachee-least-style.component';
import { CoacheePrimaryStyleComponent } from './coachee-report/coachee-primary-style/coachee-primary-style.component';
import { CoacheeScoreSummaryComponent } from './coachee-report/coachee-score-summary/coachee-score-summary.component';
import { CoacheeStyleCombinationsComponent } from './coachee-report/coachee-style-combinations/coachee-style-combinations.component';
import { CoacheeSecondCombinationsComponent } from './coachee-report/coachee-second-combinations/coachee-second-combinations.component';
import { CoacheeStyleExpressionComponent } from './coachee-report/coachee-style-expression/coachee-style-expression.component';
import { CoacheeSecondaryStyleComponent } from './coachee-report/coachee-secondary-style/coachee-secondary-style.component';

@NgModule({
  declarations: [
    FrontPageComponent,
    ImprovementsComponent,
    IntroductionComponent,
    LeastStyleComponent,
    PrimaryStyleComponent,
    ReportComponent,
    ScoreSummaryComponent,
    SecondaryStyleComponent,
    StyleCombinationsComponent,
    StyleExpressionComponent,
    StylesComponent,
    CoacheeLeastStyleComponent,
    CoacheePrimaryStyleComponent,
    CoacheeScoreSummaryComponent,
    CoacheeStyleCombinationsComponent,
    CoacheeSecondCombinationsComponent,
    CoacheeStyleExpressionComponent,
    CoacheeSecondaryStyleComponent,
  ],
  imports: [
    CommonModule,
    LibChartModule
  ],
  exports: [
    ReportComponent
  ],
})
export class LibReportModule { }
